module.exports = __webpack_public_path__ + "static/btn_old.7069086f.png";